import React from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageUploader from "quill-image-uploader";
import ImageResize from "quill-image-resize-module-react";

Quill.register("modules/imageUploader", ImageUploader);
Quill.register("modules/imageResize", ImageResize);

const ReactQuillTextEditor = ({ value, setValue, isError, loading }) => {
  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ["bold", "italic", "underline", "strike", "blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
    imageResize: {
      modules: ["Resize", "DisplaySize"],
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "indent",
    "image",
    "link",
    "blockquote",
    "code-block",
    "imageBlot",
  ];

  return (
    <ReactQuill
      id="blogContent"
      name="blogContent"
      className={`formInput ${isError ? "formError" : ""}`}
      placeholder="Enter Detail..."
      value={value}
      onChange={setValue}
      modules={modules}
      formats={formats}
      readOnly={loading} 
    />
  );
};

export default ReactQuillTextEditor;